export default __webpack_public_path__ + "static/media/build-stream.72a6d9d9.svg";